module.exports = __webpack_public_path__ + "static/img/guarantee2.f8cb9f96.png";